import { render, staticRenderFns } from "./PrescriptionDrawingPage.vue?vue&type=template&id=715fd36e&"
import script from "./PrescriptionDrawingPage.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionDrawingPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionDrawingPage.vue?vue&type=style&index=0&id=715fd36e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports